"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var I18n = require("i18n-js");
var lodash_1 = require("lodash");
// Given an error caught from a graphql mutation,
// returns an array of parsed validation error messages.
// NOTE: This assumes that a single flat list of error messages
// is expected from the graphql operation, so it may not be
// suitable for a multi-mutation operation.
// See tests for examples.
function parseGraphqlErrors(errorResponse) {
    var graphqlErrors = (lodash_1.get(errorResponse, 'graphQLErrors') || []);
    var parsedErrors = lodash_1.flatten(graphqlErrors.map(function (e) { return lodash_1.get(e, 'extensions.errors'); }));
    if (!lodash_1.compact(parsedErrors).length) {
        return defaultGraphqlErrors();
    }
    return parsedErrors;
}
exports.parseGraphqlErrors = parseGraphqlErrors;
function defaultGraphqlErrors() {
    return ([
        {
            message: I18n.t('commons.errorDisplay.message'),
            field: '',
            context: '',
            errorType: '',
        },
    ]);
}
exports.defaultGraphqlErrors = defaultGraphqlErrors;
//# sourceMappingURL=parse_graphql_errors.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/parse_graphql_errors.js
// module id = 4Gw+
// module chunks = 20 21 22